import Device from '../../../../../../../../../../../constants/deviceSizes';

export default {
  container: {
    display: 'flex',
    width: '26%',
    margin: '0px 5px 10px 0',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    [Device.mobile]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '5px 0px'
    }
  },
  titleDetail: {
    marginRight: 10
  }
};
